/* Campul de simulare grafica din cos - vezi
   snippets/studiocolors-simulare-aplicare.liquid pentru de ce si cum.
   Sta in asset, nu in snippet: snippetul se randeaza de doua ori pe /cart
   (sertar + pagina), iar sertarul se re-randeaza prin Section Rendering API,
   unde un <script> injectat nu se mai executa. Elementul personalizat se
   ridica singur la fiecare inserare in pagina - de-aia nu e MutationObserver. */

(function () {
  if (!window.customElements || customElements.get('sc-simulare-aplicare')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MAX_BYTES = 19 * 1024 * 1024;
  var PREFIX = 'Simulare ';

  function jsonPost(cale, corp) {
    return fetch(ROOT + cale, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(corp)
    });
  }

  class ScSimulareAplicare extends HTMLElement {
    connectedCallback() {
      if (this._pornit) return;
      this._pornit = true;

      this.input = this.querySelector('[data-input]');
      this.lista = this.querySelector('[data-lista]');
      this.mesaj = this.querySelector('[data-msg]');
      this.buton = this.querySelector('[data-pick]');
      this.zona = this.querySelector('[data-drop]');
      this.maxim = parseInt(this.dataset.max || '5', 10);
      this.varianta = this.dataset.variant;

      var self = this;

      this.buton.addEventListener('click', function () { self.input.click(); });
      this.input.addEventListener('change', function () {
        /* ⚠ `input.files` e o lista VIE. `input.value = ''` o goleste, deci
           fisierele se copiaza intr-un array INAINTE de golire. Altfel
           `primeste()` primea zero fisiere si nu se incarca nimic. */
        var f = Array.prototype.slice.call(self.input.files);
        self.input.value = '';
        self.primeste(f);
      });

      ['dragenter', 'dragover'].forEach(function (ev) {
        self.zona.addEventListener(ev, function (e) {
          e.preventDefault();
          self.zona.classList.add('is-over');
        });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        self.zona.addEventListener(ev, function (e) {
          e.preventDefault();
          self.zona.classList.remove('is-over');
        });
      });
      this.zona.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) self.primeste(e.dataTransfer.files);
      });

      this.lista.addEventListener('click', function (e) {
        var b = e.target.closest('[data-del]');
        if (b) self.sterge(b.getAttribute('data-del'));
      });

      if (this.dataset.orfan) this.curataLinie(this.dataset.orfan);
    }

    spune(text, rau) {
      this.mesaj.hidden = !text;
      this.mesaj.textContent = text || '';
      this.mesaj.classList.toggle('sc-sim__msg--rau', !!rau);
    }

    sloturiLuate() {
      return Array.prototype.map.call(
        this.lista.querySelectorAll('[data-slot]'),
        function (li) { return parseInt(li.getAttribute('data-slot'), 10); }
      );
    }

    slotLiber() {
      var luate = this.sloturiLuate();
      for (var i = 1; i <= this.maxim; i++) {
        if (luate.indexOf(i) === -1) return i;
      }
      return 0;
    }

    adaugaInLista(slot, nume, url) {
      var li = document.createElement('li');
      li.className = 'sc-sim__item';
      li.setAttribute('data-slot', slot);
      var a = document.createElement('a');
      a.className = 'sc-sim__name';
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = nume;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sc-sim__del';
      b.setAttribute('data-del', slot);
      b.textContent = 'Șterge';
      li.appendChild(a);
      li.appendChild(b);
      this.lista.appendChild(li);
    }

    async primeste(fisiere) {
      if (!fisiere || !fisiere.length) return;
      this.buton.disabled = true;
      var textVechi = this.buton.textContent;
      this.buton.textContent = 'Se încarcă...';
      this.spune('');

      try {
        for (var i = 0; i < fisiere.length; i++) {
          var f = fisiere[i];
          var slot = this.slotLiber();
          if (!slot) {
            this.spune('Ai deja ' + this.maxim + ' fișiere. Șterge unul ca să pui altul.', true);
            break;
          }
          if (f.size > MAX_BYTES) {
            this.spune('„' + f.name + '" are peste 19 MB. Shopify nu îl acceptă. Micșorează-l sau trimite-l ca PDF.', true);
            continue;
          }
          await this.urca(f, slot);
        }
      } catch (err) {
        this.spune('Fișierul nu a intrat: ' + (err && err.message ? err.message : 'eroare necunoscută') + '. Încearcă din nou sau scrie-ne pe WhatsApp.', true);
      }

      this.buton.disabled = false;
      this.buton.textContent = textVechi;
    }

    async urca(fisier, slot) {
      /* 1. linia ajutatoare duce fisierul la Shopify */
      var fd = new FormData();
      fd.append('id', this.varianta);
      fd.append('quantity', '1');
      fd.append('properties[_sc_simulare_temp]', '1');
      fd.append('properties[Simulare]', fisier, fisier.name);

      var res = await fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd });
      if (!res.ok) {
        var d = null;
        try { d = await res.json(); } catch (e) {}
        throw new Error((d && (d.description || d.message)) || ('eroare ' + res.status));
      }
      var linie = await res.json();
      var url = linie.properties && linie.properties.Simulare;
      if (!url) throw new Error('Shopify nu a întors adresa fișierului');

      /* 2. adresa se salveaza INTAI, ca sa nu se piarda daca pasul 3 cade */
      var atribute = {};
      atribute[PREFIX + slot] = fisier.name + ' — ' + url;
      await jsonPost('cart/update.js', { attributes: atribute });

      /* 3. abia acum se scoate linia ajutatoare din cos */
      await this.curataLinie(linie.key);

      this.adaugaInLista(slot, fisier.name, url);
      this.spune('Gata. Simularea a intrat pe comandă.');
    }

    async curataLinie(cheie) {
      for (var incercare = 0; incercare < 2; incercare++) {
        var res = await jsonPost('cart/change.js', { id: cheie, quantity: 0 });
        if (!res.ok) continue;
        var cos = await res.json();
        var ramas = (cos.items || []).some(function (it) {
          return it.properties && it.properties._sc_simulare_temp;
        });
        if (!ramas) return true;
      }
      this.spune('Fișierul e salvat, dar a rămas o linie de 0,01 lei în coș. Scoate-o sau scrie-ne pe WhatsApp înainte de plată.', true);
      return false;
    }

    async sterge(slot) {
      var atribute = {};
      atribute[PREFIX + slot] = '';
      var res = await jsonPost('cart/update.js', { attributes: atribute });
      if (!res.ok) {
        this.spune('Nu am putut șterge fișierul. Reîncarcă pagina.', true);
        return;
      }
      var li = this.lista.querySelector('[data-slot="' + slot + '"]');
      if (li) li.remove();
      this.spune('Fișierul a fost scos de pe comandă.');
    }
  }

  customElements.define('sc-simulare-aplicare', ScSimulareAplicare);
})();
